import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PreventBackButton = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const preventBack = () => {
      window.history.pushState(null, "", window.location.href);
      window.history.replaceState(null, "", window.location.href); // 履歴を完全固定
    };

    const handlePopState = (event: PopStateEvent) => {
      event.preventDefault();
      preventBack(); // 何度戻るボタンを押しても履歴が固定される
      navigate(window.location.pathname); // ルートを変えない
    };

    const handleDoubleBack = () => {
      setTimeout(() => {
        preventBack(); // ダブルクリック対応：一定時間後に再適用
      }, 100); //  100ms 以内の戻る操作も防ぐ
    };

    preventBack(); 
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("popstate", handleDoubleBack);
    window.addEventListener("beforeunload", preventBack);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("popstate", handleDoubleBack);
      window.removeEventListener("beforeunload", preventBack);
    };
  }, [navigate]);

  return null;
};

export default PreventBackButton;